import CloseIcon from './assets/close-icon-new.svg?raw';
import SuccessIcon from './assets/icons/check-circle.svg?raw';
import WarningIcon from './assets/icons/exclamation-circle.svg?raw';
import InfoIcon from './assets/icons/info-circle.svg?raw';
import ErrorIcon from './assets/icons/times-circle.svg?raw';

export default {
  render(title, text, color, icon, time = 5000, position = 'bottom-left') {
    const container = document.createElement('div');
    container.classList.add(
      'p-4',
      'fixed',
      'z-99',
      'rounded-md', 'shadow-md', 'flex', 'bg-white', 'border',
      `border-${color}`,
      'items-center',
      'gap-1'
    );
    if(position === 'bottom-right') {
      container.style.right = '1rem';
      container.style.bottom = '1rem';
    } else if(position === 'top-right') {
      container.style.right = '1rem';
      container.style.top = '1rem';
    } else if(position === 'top-left') {
      container.style.left = '1rem';
      container.style.top = '1rem';
    } else {
      container.style.left = '1rem';
      container.style.bottom = '1rem';
    }
    container.style.width = '360px';
    container.innerHTML = `
    <div class="p-1 text-${color} rounded-full" style="background-color: color-mix(in srgb, var(--brand-${color}) 20%, white)">
      ${icon.replace('<svg', '<svg class="fill-current h-4 w-4" ')}
    </div>
    <div class="flex-grow flex-col text-grey-500">
      <div class="">${title}</div>
      <div class="text-sm">${text}</div>
    </div>
    <div class="close text-grey-500 cursor-pointer">
      ${CloseIcon.replace('<svg', '<svg class="fill-current h-4 w-4" ') }
    </div>`;
    container.querySelectorAll('.close')[0].addEventListener('click', () => {
      container.remove();
    });
    document.body.appendChild(container);
    setTimeout(() => {
      container.remove();
    }, time);
    return container;
  },
  info(title, position, text = '', time) {
    return this.render(title, text, 'info', InfoIcon, time, position);
  },
  success(title, position, text = '', time) {
    return this.render(title, text, 'success', SuccessIcon, time, position);
  },
  fail(title, position, text = '', time) {
    return this.render(title, text, 'danger', ErrorIcon, time, position);
  },
  warn(title, position, text = '', time) {
    return this.render(title, text, 'warning', WarningIcon, time, position);
  }
};
